export const AUTH_LANGUAGE = {
  login_enter_phone_number: "Enter Contact Number",
  login_enter_password: "Enter Password",

  login_enter_phone_number_label: "Enter Contact Number",
  login_phone_error: "Please input your Contact Number!",
  login_password_error: "Please input your password!",
  login_password_validation_msg: "Password must be less greater then 6 digit",
  login_text: "Sign In",
  login_password: "Password",
  forget_password: "Password?",
  login_password_label: "Enter Password",
  login_forget_password_text: "Forgot Password?",

  forgot_password_associate_account: "Enter the contact number associated with your account.",
  forgot_password_enter_phone_number: "Enter contact Number",
  forgot_password_phone_error: "Please input your contact Number!",
  forgot_password_password_error: "Please input your password!",
  forgot_password_password_validation_msg: "Password must be less greater then 6 digit",
  forgot_password_next: "Next",
  forgot_password_password: "Password?",
  forgot_password_text: "Forgot",
  reset_password_text: "Reset",
  login_heading_text: "Welcome to",
  login_heading_takaful_bazaar: "Takaful Bazaar",
  set_password_verify_account: "Please Enter the OTP to Verify your Account",
  set_password_otp_message: "A OTP (one time Password) has been sent to",
  set_password_reset: "Reset",
  set_password_password_text: "Password?",
  set_password_otp_required: "Please enter OTP Code.",
  set_password_enter_otp: "Enter OTP",
  reset_password_label_new_password: "New Password",
  reset_password_re_enter_password: "Confirm Password",
  reset_password_validation: "Enter New Password",
  reset_password_re_enter_password_validation_text: "Enter Confirm Password",
  set_password_label_new_password: "Enter New Password",
  set_password_new_password: "New Password",
  set_password_validation: "Please input your new password!",
  set_password_error_msg: "Password must be 6 characters long",
  set_password_confirm_password_msg: "Password must be 6 characters long",
  set_password_re_enter_password_validation_text: "Password should be same as new password",
  set_password_re_enter_password: "Re-enter Password",
  set_password_submit: "Submit",
  set_password_resend: "Resend",
  set_password_confrim_password_msg: "The new password that you entered do not match!",
  set_password_enter_otp_placeholder: "OTP Code",
  set_password_by_email_welcome_to: "Welcome to",
  set_password_by_email_takaful_bazaar: "Takaful Bazaar",
  set_password_verify_hash_error: "Token has been expired",
  set_password_password_updated_successfully: "Password Updated Successfully"
};
